// extracted by mini-css-extract-plugin
export default {"textBlock":"textBlock_textBlock__MbVu0","textBlock__table":"textBlock_textBlock__table__eWKKf"};